/**
 * Created by hengbao on 2018/2/23.
 */
function queryToJson(str) {
  str = str || location.search;
  let obj = {};
  if (str) {
    str.slice(1).split('&').forEach(function(item) {
      if (item) {
        var e = item.split('=');
        obj[e[0]] = e[1]?decodeURIComponent(e[1]):'';
      }
    });
  }
  return obj;
}
export default queryToJson



// WEBPACK FOOTER //
// ./src/common/qureyToJson.js